module.exports = __webpack_public_path__ + "img/in-mh.a5cc085f.svg";